import { Features } from "./scripts/FeatureCheck";

// LMUTV feature bits (kept in sync with src/config/plans.ts + plans.php).
//   Standard key features = LMUTV (512)
//   Pro key features      = LMUTV | LMUTVPRO (1536)  — Pro is additive on the base bit.
// STANDARD_FLAG / PRO_FLAG are the single tier bits used to CLASSIFY an owned key;
// AppFlag (= the base bit) is "is this an LMUTV key at all" and matches both tiers.
export const STANDARD_FLAG = Features.LMUTV;    // 512
export const PRO_FLAG = Features.LMUTVPRO;      // 1024

// Unique app id for Orders.app.
export const LMUTV_APP_ID = 512;

// Backwards-compat alias used by ported ACDrive components (owned-key filtering).
export var AppFlag = Features.LMUTV;

export type Edition = "standard" | "pro";
// "1d" is a renewal-testing tier — only surfaced in sandbox builds (see BuyWizard).
export type Duration = "1d" | "3m" | "1y" | "lifetime";

export const LMUTV_PRICING: Record<Edition, Record<Duration, number>> = {
  standard: { "1d": 18, "3m": 18, "1y": 65, lifetime: 120 },
  pro:      { "1d": 30, "3m": 30, "1y": 110, lifetime: 190 },
};

// Full feature bitmask a purchased key of this edition should carry.
// Pro = base LMUTV bit + Pro bit (1536); Standard = base bit (512).
export const featureForEdition = (e: Edition): number =>
  e === "pro" ? STANDARD_FLAG | PRO_FLAG : STANDARD_FLAG;

export const daysForDuration = (d: Duration): number | null =>
  d === "lifetime" ? null : d === "1d" ? 1 : d === "1y" ? 365 : 90;

// Date the issued key would be valid until if purchased today.
// null means lifetime (no expiry).
export const validUntilForDuration = (d: Duration, from: Date = new Date()): Date | null => {
  const days = daysForDuration(d);
  if (days === null) return null;
  const out = new Date(from);
  out.setDate(out.getDate() + days);
  return out;
};

export const formatValidUntil = (d: Date | null, locale: string = "de-DE"): string => {
  if (d === null) return "";
  return d.toLocaleDateString(locale, { day: "2-digit", month: "2-digit", year: "numeric" });
};
